export default "__VITE_ASSET__dRtL1oEI__"